import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-payment-user-warning',
  templateUrl: './payment-user-warning.component.html',
  styleUrl: './payment-user-warning.component.scss'
})
export class PaymentUserWarningComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public role: string,
    private dialogRef: MatDialogRef<PaymentUserWarningComponent>,
    ) {
  }

  onConfirm(){
    this.dialogRef.close(this.role);
  }

  onCancel(){
    this.dialogRef.close(null)
  }
}
